import React, { Component } from 'react'

const KeyRegisterPrices = new Map()
KeyRegisterPrices.set('atolFPrint22PTK' , {price: 52100})
KeyRegisterPrices.set('atol30F' , {price: 39500})
KeyRegisterPrices.set('atol55F' , {price: 49700})
KeyRegisterPrices.set('atol11F' , {price: 44400})
KeyRegisterPrices.set('atol11FMobile' , {price: 49400})
KeyRegisterPrices.set('atol90F' , {price: 40900})
KeyRegisterPrices.set('evotor72' , {price: 47200})
KeyRegisterPrices.set('evotor73' , {price: 50700})
KeyRegisterPrices.set('evotor10' , {price: 55875})
KeyRegisterPrices.set('k1f' , {price: 40500})


const KktRegisterPrices = new Map()
KktRegisterPrices.set('atolFPrint22PTK' , {price: 26500, fiskal: 38500})
KktRegisterPrices.set('atol30F' , {price: 12500 , fiskal: 24500})
KktRegisterPrices.set('atol55F' , {price: 24300, fiskal: 36300})
KktRegisterPrices.set('atol11F' , {price: 17800, fiskal: 29800})
KktRegisterPrices.set('atol11FMobile' , {price: 22800, fiskal: 34800})
KktRegisterPrices.set('atol90F' , {price: 11400, fiskal: 23400})
KktRegisterPrices.set('evotor72' , {price: 20000, fiskal: 32000})
KktRegisterPrices.set('evotor73' , {price: 25000, fiskal: 37000})
KktRegisterPrices.set('evotor10' , {price: 30500, fiskal: 42500})
KktRegisterPrices.set('k1f' , {price: 14500, fiskal: 26500})

const ServicePrices = new Map()
ServicePrices.set('kktactivation', 3000)
ServicePrices.set('abonent', 570)
ServicePrices.set('signature', 2000)
ServicePrices.set('techicalLkFns', 2000)
ServicePrices.set('techicalLkOfd', 2000)
ServicePrices.set('fiskalizationAndFNS', 1500)
ServicePrices.set('connectOfd', 1500)
ServicePrices.set('kktSoft', 1000)
ServicePrices.set('delivery', 1500)

class Price extends Component {
  render() {

    switch(this.props.mode) {
      case 'key':
        return(
          <div className="tile is-12 is-child box">
            <span style={{fontSize: '16pt', color: '#4fa800'}}>{KeyRegisterPrices.get(this.props.register).price} руб</span>
          </div>
        )
      case 'kkt':

        let price = KktRegisterPrices.get(this.props.register).price
        let monthlyPrice = 0

        if(this.props.fiskal) {
          price = KktRegisterPrices.get(this.props.register).fiskal
        }
        if(this.props.activationCode) {
          price += 3000
        }
        if(this.props.signature) {
          price += ServicePrices.get('signature')
        }
        if(this.props.techicalLkFns) {
          price += ServicePrices.get('techicalLkFns')
        }
        if(this.props.techicalLkOfd) {
          price += ServicePrices.get('techicalLkOfd')
        }
        if(this.props.fiskalizationAndFNS) {
          price += ServicePrices.get('fiskalizationAndFNS')
        }
        if(this.props.connectOfd) {
          price += ServicePrices.get('connectOfd')
        }
        if(this.props.delivery) {
          price += ServicePrices.get('delivery')
        }

        if(this.props.abonent) {
          monthlyPrice += ServicePrices.get('abonent')
        }
        if(this.props.kktSoft) {
          monthlyPrice += ServicePrices.get('kktSoft')
        }
        
        return(
          <div className="tile is-12 is-child box">
            <span style={{fontSize: '16pt', color: '#4fa800'}}>{ price + (monthlyPrice * 12)} руб </span>
          </div>
        )

      case 'service':
        let servicePrice = 0
        if(this.props.kktactivation) {
          servicePrice += ServicePrices.get('kktactivation')
        }
        return(
          <div className="tile is-12 is-child box">
            <span style={{fontSize: '16pt', color: '#4fa800'}}>{ servicePrice } руб</span>
          </div>
        )
      default:
        return(
          <div className="tile is-12 is-child box">
            <p>Нет цены</p>
          </div>
        )
    }
  }
}

export default Price


// WEBPACK FOOTER //
// ./src/components/ofdCalc/price/Price.js